var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.083 6.417H5.25v1.166H4.083V6.417zM12.25 3.5v8.167a1.17 1.17 0 0 1-1.167 1.166H2.917a1.166 1.166 0 0 1-1.167-1.166L1.756 3.5c0-.642.513-1.167 1.16-1.167H3.5V1.167h1.167v1.166h4.666V1.167H10.5v1.166h.583A1.17 1.17 0 0 1 12.25 3.5zM2.917 4.667h8.166V3.5H2.917v1.167zm8.166 7V5.833H2.917v5.834h8.166zM8.75 7.583h1.167V6.417H8.75v1.166zm-2.333 0h1.166V6.417H6.417v1.166z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCalendar);
export default __webpack_public_path__ + "static/media/ic_calendar.26259a0c66d2cf8184ef07cfec34e2f7.svg";
export { ForwardRef as ReactComponent };